<template>
    <div>
        <table class="table is-fullwidth">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Created</th>
                    <th>Actions</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="(team, index) in teams" :key="team.id">
                    <th>{{ index + 1 }}</th>

                    <td>
                        {{ team.name }} &nbsp;
                        <role v-if="team.is_owner" role="owner"/>
                    </td>

                    <td><base-datetime :date="team.created_at"/></td>

                    <td>
                        <div class="tags" :class="{'disabled': !team.is_owner}">
                            <a @click="update_team(team)" class="icon fas fa-pen tag"></a>
                            <a @click="update_members(team)" class="icon fas fa-users tag"></a>
                            <a @click="delete_team(team)" class="icon fas fa-trash-alt tag"></a>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <team-update
            v-if="update_team_id"
            @close="close_update"
            @updated="after_update"
            :visible="show_update"
            :team_id="update_team_id"/>

        <team-members-modal
            v-if="members_team_id"
            @close="close_members"
            :visible="show_members"
            :team_id="members_team_id"/>

        <base-paginator
            :total-count="totalCount"
            :per-page="15"
            :current="parseInt($route.query.page || 1)"/>
    </div>
</template>

<script>
import Role from '../common/Role.vue';
import TeamUpdate from './TeamUpdate.vue';
import TeamMembersModal from './TeamMembersModal.vue';

export default {
    name: 'TeamList',
    components: { TeamUpdate, TeamMembersModal, Role },
    props: ['teams', 'totalCount'],
    data() {
        return {
            show_update: false,
            update_team_id: null,
            show_members: false,
            members_team_id: null,
        };
    },
    methods: {
        update_team(team) {
            if (!team.is_owner) return;
            this.show_update = true;
            this.update_team_id = team.id;
        },
        after_update() {
            this.$emit('updated');
            this.close_update();
        },
        update_members(team) {
            if (!team.is_owner) return;
            this.show_members = true;
            this.members_team_id = team.id;
        },
        delete_team(team) {
            if (!team.is_owner) return;
            // eslint-disable-next-line no-restricted-globals,no-alert
            if (confirm('Do you really want to remove this Team?')) {
                this.$store.dispatch('teams/remove', { team_id: team.id })
                    .then(() => this.$emit('removed'));
            }
        },
        close_members() {
            this.show_members = false;
            this.members_team_id = null;
        },
        close_update() {
            this.show_update = false;
            this.update_team_id = null;
        },
    },
};
</script>

<style scoped>
    .disabled a {color: #d0d0d0; cursor: not-allowed;}
</style>
